export default class Menu {
	constructor() {
		this.DOM = {};
		this.DOM.el = document.querySelector('[data-menu="el"]');
		this.DOM.triggerEl = this.DOM.el.querySelector('[data-menu="trigger"]');

		this.onTriggerClick = this.onTriggerClick.bind(this);
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.DOM.triggerEl.addEventListener('click', this.onTriggerClick);
	}

	onTriggerClick(e) {
		e.preventDefault();
		this.DOM.el.classList.toggle('is-open');
	}
}